
let progressBox = document.querySelectorAll('.status-box-item');
if(progressBox){
    progressBox.forEach(box=>{
        let status = parseFloat(box.querySelector('.count-up').textContent);
        let progress = box.querySelector('.status-box-progress');
        progress.style.setProperty('--status', status + '%');
        box.classList.add('animated-count');
    })
}